import { Site } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { PrizeDetail } from '@swf/core/types/CasinoRaces';
import { PrizeType } from '@swf/core/types/CasinoRaces';

import {
  TXTCLI_Bonus,
  TXTMOB_Instant_Bonus,
  TXTWCL_Cash,
  TXTWCL_Free_Spins
} from './Title.messages.json';

export interface Props {
  prizeDetails: PrizeDetail;
}

const Title: React.FC<Props> = ({ prizeDetails }) => {
  const site = useSelector(select.cms.getSiteId);
  switch (prizeDetails.prizeType) {
    case PrizeType.IB:
      return <Translation {...TXTMOB_Instant_Bonus} />;
    case PrizeType.FSB:
      return <Translation {...TXTWCL_Free_Spins} />;
    case PrizeType.CASH:
    default:
      return <Translation {...([Site.IT, Site.PT].includes(site) ? TXTCLI_Bonus : TXTWCL_Cash)} />;
  }
};

export default Title;
